<template>
  <div class="demo-ruleForm">
    <h1>{{ msg }}</h1>
    <el-form :model="user" label-width="100px">
      <el-form-item label="账号" prop="pass">
        <el-input type="text" v-model="user.username" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="checkPass">
        <el-input type="password" v-model="user.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm()" :loading="loading">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import cookie from './../../util/cookie'
export default {
  name: 'login',
  data() {
    return {
      msg: '系统登录',
      user: {},
      loading: false,
    }
  },

  methods: {
    submitForm() {
      this.loading = true;
      axios.post('/login', this.user).then((response) => {
        cookie.setCookie('xToken',response.data.sessionToken, 7);
        localStorage.setItem('openUser', JSON.stringify(response.data))
        this.$router.push({ path: '/cabinets' });
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.demo-ruleForm {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/views/login/Login.vue?b4ce72d0